module.exports = __webpack_public_path__ + "static/media/mini-partitura.ec3708c0.png";